<template>
  <!-- 信息监测组件 -->
  <div class="info-monitor">
    <ul class="tab-wrap">
      <li v-for="(item,index) in tabList" :key="index" :class="activeTab === item? 'active-bg':''"
        @click="changeTab(item)">{{item}}</li>
    </ul>
    <div v-if="activeTab === '基本信息'" style="height:calc(100% - 60px)">
      <!-- 基本信息 -->
      <baseInfo :userData="userData" />
    </div>
    <div v-if="activeTab === '生化指标'" style="height:calc(100% - 60px)">
      <!-- 基本信息 -->
      <Biochemical :userData="userData" />
    </div>
    <div v-if="activeTab === '筛查评估'" style="height:calc(100% - 60px)">
      <screeningAssessment :userData="userData"></screeningAssessment>
    </div>
    <div v-if="activeTab === '体征监测'" style="height:calc(100% - 60px)">
      <!-- 基本信息 -->
      <Physical :userData="userData" />
    </div>
    <div v-if="activeTab === '科研服务'" style="height:calc(100% - 54px)">
      <!-- 科研服务 -->
      <ScientificService :userData="userData" />
    </div>
    <div v-if="activeTab === 'PICC置管监测'" style="height:calc(100% - 76px)">
      <!-- PICC置管监测 -->
      <picc :userData="userData" />
    </div>
  </div>
</template>

<script>
import screeningAssessment from "./ScreeningAssessment";
import baseInfo from "./baseInfo.vue";
import Biochemical from "./Biochemical.vue";
import Physical from "./Physical.vue";
import ScientificService from "./ScientificService.vue";
import Picc from "./picc.vue";
import local from "@/utils/local.js";

export default {
  name: "InfoMonitor",
  components: {
    screeningAssessment,
    baseInfo,
    Biochemical,
    Physical,
    ScientificService,
    Picc
  },
  props: {
    userData: {
      type: Object,
      default: () => {}
    },
    IMInfo: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    userData: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) {
        }
      }
    }
  },
  data() {
    return {
      tabList: [
        "基本信息",
        "生化指标",
        "筛查评估",
        "体征监测",
        "科研服务",
        "PICC置管监测"
      ],
      activeTab: local.get('tabActiveItem') || "基本信息"
    };
  },
  methods: {
    changeTab(item) {
      this.activeTab = item;
      local.set('tabActiveItem', item)
    }
  }
};
</script>

<style lang="less" scoped>
/* // @import './index'; */
.info-monitor {
  width: 100%;
  height: calc(100% - 138px);
  .tab-wrap {
    display: flex;
    background-color: #fff;
    padding: 16px;
    border-radius: 6px;
    li {
      font-size: 14px;
      color: #333333;
      border-radius: 4px;
      padding: 5px 10px;
      margin-right: 20px;
      cursor: pointer;
    }
  }
  .active-bg {
    background-color: #1a7bfc;
    color: #fff !important;
  }
}
</style>